import React, { useEffect, useState } from "react";
import Checkbox from "../../../generic/checkbox";
import { OtpSection } from "../../generic/otpSection";
import { config } from "../../../../config/domain";
import { 
    EqPositions, CommPositions, EqOrderbook, CommOrderbook, MfOrderbook, MfSipOrderbook, createSegmentDeactivationSR, validateSegmentDeactivation 
} from "../../../service/serviceRequest/srApiService";
import LoginService, { getAccData } from "../../../service/login/loginService";
import "../../../../assets/scss/components/clientarea/serviceRequest/segmentSR.scss";
import { asyncGetPersonalDetails } from "../../../service/postLogin/clientProfileAPIService";
import { allowedSegmentsCOM, allowedSegmentsComEq, allowedSegmentsEQ, curDerivatives, eqDerivatives, errorMsg, segmentDeactivationMsg, segmentNamesSMS } from "./constant";
import PageLoader from "../../../generic/loader";

export interface IErrorType {
	openOrder?: boolean;
    openSIP?: boolean;
    openPosition?: boolean;
}

interface IActiveSegDetailsSub{
    NSEFO?: boolean;
    BSEFO?: boolean;
    NSECDS?: boolean;
    BSECDS?: boolean;
    BSEMFSS?: boolean;
    COMNCDEX?: boolean;
    COMMCX?: boolean;
}

export const SegmentDeactivation = (props: any) => {
    const [email, setEmail] = useState("");
    const [mobile, setMobile] = useState("");
    const [loader, setLoader] = useState<boolean>(false);
    const [otpSection, setOtpSection] = useState<boolean>(false);
    const [otpVerified, setOtpVerified] = useState<boolean>(false);
    const [disableSubmit, setDisableSubmit] = useState<boolean>(false);
    const [validationErr, setValidationErr] = useState({
        openOrder: false,
        openSIP: false,
        openPosition: false
    });
    const [activeSegDetails, setActiveSegDetails] = useState({
        activeSegments: {} as any, // NSEFO?: false, NSECDS?: false, BSEMFSS?: false, COMMCX?: false, COMNCDEX?: false
        selectSegment: {} as any //IActiveSegDetailsSub,
    });
    const [segmentValidation, setSegmentValidation] = useState({
        BSEMFSS_SIP:false,   //sip
        NSEFO_OP: false, BSEFO_OP: false, NSECDS_OP: false, BSECDS_OP: false, COM_OP: false,   //open position   
        NSEFO_OO: false, BSEFO_OO: false, NSECDS_OO: false, BSECDS_OO: false, BSEMFSS_OO: false, COM_OO: false,   //open order 
    });

    React.useEffect(() => {
        getSegmentDetails();
    }, []);

    useEffect(()=>{
        checkSegmentValidation()
    },[activeSegDetails.selectSegment])

    const validateComOO = async () => {
        var CommObResult = await CommOrderbook();
        var CommOrderbookRes = CommObResult.data?.ord && CommObResult.data.ord.filter((ele: any) => {
            return ele.sts.toLowerCase() === "open";
        });
        if(CommOrderbookRes && CommOrderbookRes.length > 0){
            return true;
        }
        return false;
    }
    const validateComOP = async () => {
        var CommPositionsRes = await CommPositions();
        if(CommPositionsRes.data?.pos && CommPositionsRes.data.pos.length > 0){
            return true;
        }
        return false;
    }
    const valiadteMfOO = async () => {
        const MfObResult = await MfOrderbook();
        var MfOrderbookRes = MfObResult.data?.ordLst && MfObResult.data.ordLst.filter((ele: any) => {
            return ele.status.toLowerCase() === "open";
        });
        if(MfOrderbookRes && MfOrderbookRes.length > 0){
            return true;
        }
        return false;
    }
    const valiadteMfOP = async () => {
        const MfSipObResult = await MfSipOrderbook();
        var MfSipOrderbookRes = MfSipObResult.data?.sipOrdLst && MfSipObResult.data.sipOrdLst.filter((ele: any) => {
            return ele.status.toLowerCase() === "running";
        });
        if(MfSipOrderbookRes && MfSipOrderbookRes.length > 0){
            return true;
        }
        return false;
    }
    const validateCurDerOO = async () => {
        const EqObResult = await EqOrderbook();
        var scriptTyp = curDerivatives;
        var EqOrderbookRes = EqObResult.data?.ord && EqObResult.data.ord.filter((ele: any) => {
            return (
                ele.sts.toLowerCase() == "open" && scriptTyp.indexOf(ele.asTyp)>-1
            )
        });
        if(EqOrderbookRes && EqOrderbookRes.length > 0){
            return true;
        }
        return false;
    }
    const validateCurDerOP = async () => {
        const EqPositnResult = await EqPositions();
        var scriptTyp = curDerivatives;
        var EqPositionsRes = EqPositnResult.data?.pos && EqPositnResult.data.pos.filter((ele: any) => {
            return ( scriptTyp.indexOf(ele.pstns[0].asTyp) > -1 );
        });
        if(EqPositionsRes && EqPositionsRes.length > 0){
            return true;
        }
        return false;
    }
    const validateEqDerOO = async () => {
        const EqObResult = await EqOrderbook();
        var scriptTyp = eqDerivatives;
        var EqOrderbookRes = EqObResult.data?.ord && EqObResult.data.ord.filter((ele: any) => {
            return (
                ele.sts.toLowerCase() == "open" && scriptTyp.indexOf(ele.asTyp)>-1
            )
        });
        if(EqOrderbookRes && EqOrderbookRes.length > 0){
            return true;
        }
        return false;
    }
    const validateEqDerOP = async () => {
        const EqPositnResult = await EqPositions();
        var scriptTyp = eqDerivatives;
        var EqPositionsRes = EqPositnResult.data?.pos && EqPositnResult.data.pos.filter((ele: any) => {
            return ( scriptTyp.indexOf(ele.pstns[0].asTyp) > -1 );
        });
        if(EqPositionsRes && EqPositionsRes.length > 0){
            return true;
        }
        return false;
    }
    const validateActiveSegments = async (activeSegments: any) => {
        var activeSegmentNames = Object.keys(activeSegments);
        var NSEFO_OO:any = false,
        BSEFO_OO:any = false,
        NSECDS_OO:any = false,
        BSECDS_OO:any = false,
        BSEMFSS_OO:any= false,
        COM_OO:any= false,
        BSEMFSS_SIP:any=false,
        NSEFO_OP:any= false,
        BSEFO_OP:any= false,
        NSECDS_OP:any= false,
        BSECDS_OP:any= false,
        COM_OP:any= false;
        for (var i = 0; i < activeSegmentNames.length; i++) {
            var segment = activeSegmentNames[i];
                if(segment == 'NSEFO'){
                    NSEFO_OO = await validateEqDerOO();
                    NSEFO_OP = await validateEqDerOP();
                } 
                else if(segment == 'BSEFO'){
                    BSEFO_OO = await validateEqDerOO();
                    BSEFO_OP = await validateEqDerOP();
                } else if(segment == 'NSECDS'){
                    NSECDS_OO = await validateCurDerOO();
                    NSECDS_OP = await validateCurDerOP();
                } 
                else if(segment == 'BSECDS'){
                    BSECDS_OO = await validateCurDerOO();
                    BSECDS_OP = await validateCurDerOP();
                } else if(segment == 'BSEMFSS'){
                    BSEMFSS_OO = await valiadteMfOO();
                    BSEMFSS_SIP = await valiadteMfOP();
                } else if(segment == 'COMNCDEX' || segment == 'COMMCX'){
                    COM_OO = await validateComOO();
                    COM_OP = await validateComOP();
                }
            }
        setSegmentValidation({
            ...segmentValidation, NSEFO_OO, NSEFO_OP, BSEFO_OO, BSEFO_OP, NSECDS_OO, NSECDS_OP, BSECDS_OO, BSECDS_OP,BSEMFSS_OO, BSEMFSS_SIP, COM_OO, COM_OP
        })
        props.setParLoader(false);
        setLoader(false);
    }
    const getSegmentDetails = async () => {
        props.setParLoader(true);
        setLoader(true);
        try {
            const validateSegmentRes = await validateSegmentDeactivation();
            if (validateSegmentRes &&
                validateSegmentRes.hasOwnProperty("data") && 
                validateSegmentRes.data.hasOwnProperty("value")
            ){
                const value = JSON.parse(validateSegmentRes.data.value);
                if (value && Array.isArray(value.result) && value.result.length > 0) {
                    var allowedSegments = (getAccData("accTyp") === "EQ" ? allowedSegmentsEQ : (getAccData("accTyp") === "CO" ? allowedSegmentsCOM : allowedSegmentsComEq));
                    var activeSegments: any = {}; 
                    var selectSegment: any = {};
                    var segmentList = value.result[0].ActiveSegment;
                    for (var i = 0; i < segmentList.length; i++) {
                        var segName = segmentList[i].key.replace("_", "");
                        if (segmentList[i].value == "Y" && allowedSegments.indexOf(segName)>-1) {
                            activeSegments[segName] = true;
                            selectSegment[segName] = false;
                        }
                    }  
                    setActiveSegDetails({
                        ...activeSegDetails, activeSegments, selectSegment
                    }) 
                    validateActiveSegments(activeSegments);
                } else {
                    props.setParLoader(false);
                    setLoader(false);
                    openSRErrorPopup()
                }
            } else {
                props.setParLoader(false);
                setLoader(false);
                openSRErrorPopup()
            }
        } catch (error) {
            props.setParLoader(false);
            setLoader(false);
            openSRErrorPopup();
        }
    }
    const getSegNames = () => {
        var selectedSegments = Object.keys(activeSegDetails.selectSegment);
        var segname = "";
        for (var i = 0; i < selectedSegments.length; i++) {
            if (activeSegDetails.selectSegment[selectedSegments[i]]) {
                segname = segname + segmentNamesSMS[selectedSegments[i] as keyof typeof segmentNamesSMS] + ", ";
            }
        }
        segname= segname.slice(0, -2);
        let newSegnames = segname.split(",")
        let tempArr : any = [];
        newSegnames.forEach((ele) => {
            if(!tempArr.includes(ele.trim())) {
             tempArr.push(ele.trim())
            }
        })
        let finalSegnames = tempArr.join(",")
        return finalSegnames;
    };
    const checkSegEnabled = () => {
        var selectedSegments = Object.keys(activeSegDetails.selectSegment);   
        for (var i = 0; i < selectedSegments.length; i++) {
            if (activeSegDetails.selectSegment[selectedSegments[i]]) {
                return false;
            }
        }
        return true;
    };   
    const checkSegmentValidation = () => {
        var openSIP = activeSegDetails.selectSegment?.BSEMFSS && segmentValidation.BSEMFSS_SIP;
        var openPosition = ((activeSegDetails.selectSegment?.NSEFO && segmentValidation.NSEFO_OP) ||
            (activeSegDetails.selectSegment?.BSEFO && segmentValidation.BSEFO_OP) ||
            (activeSegDetails.selectSegment?.NSECDS && segmentValidation.NSECDS_OP) ||
            (activeSegDetails.selectSegment?.BSECDS && segmentValidation.BSECDS_OP) ||
            (activeSegDetails.selectSegment?.COMMCX && activeSegDetails.selectSegment?.COMNCDEX && segmentValidation.COM_OP));
        var openOrder = ((activeSegDetails.selectSegment?.NSEFO && segmentValidation.NSEFO_OO) ||
            (activeSegDetails.selectSegment?.BSEFO && segmentValidation.BSEFO_OO) ||
            (activeSegDetails.selectSegment?.NSECDS && segmentValidation.NSECDS_OO) ||
            (activeSegDetails.selectSegment?.BSECDS && segmentValidation.BSECDS_OO) ||
            (activeSegDetails.selectSegment?.BSEMFSS && segmentValidation.BSEMFSS_OO) ||
            (activeSegDetails.selectSegment?.COMMCX && activeSegDetails.selectSegment?.COMNCDEX && segmentValidation.COM_OO))
        setValidationErr({ ...validationErr, openSIP, openPosition, openOrder })
    }
    const isImpersonated = () => {
        return window.localStorage.getItem("isImpersonated");
    };
    const proceedNext = async () => {
        if (isImpersonated() && !otpVerified) {
            const profile = await asyncGetPersonalDetails();
            setMobile(profile.mobileNumberField);
            setEmail(profile.emailAddressField);
            setOtpSection(true);
          } else {
            setOtpSection(false);
            submitDetails();
          }
    }

    const openSRErrorPopup = (mess?: string) => {
        props.setParLoader(false);
        props.onSubmit("segmentDeactivation", {
          headerText: mess ? mess : segmentDeactivationMsg.error,
        });
    };    
    const openSRSuccessPopup = () => {
        props.setParLoader(false);
        let paramObj: any = {
            popUp2: true,
            popupType: "Success",
            type: "Segment Deactivation",
            iconName: "edel-icon-green-circle-tick",
            content: segmentDeactivationMsg.createSR.content,
            contentBold: getSegNames(),
            redirectionLink: segmentDeactivationMsg.createSR.redirectionLink,
            redirectionText: segmentDeactivationMsg.createSR.redirectionText
        };
        props.onSubmit("segmentDeactivation", paramObj);
    };
    const openExistSrPopup = () => {
        props.setParLoader(false);
        props.onSubmit("segmentDeactivation", {
            headerText: segmentDeactivationMsg.SRexists.headerText,
            content: segmentDeactivationMsg.SRexists.content,
        });
    };
    const submitDetails = async () => {
        setDisableSubmit(true);
        try {
            props.setParLoader(true);
            setLoader(true);
            var selectedSegmnetsReq: Array<any> = [];
            var selectedSegments = Object.keys(activeSegDetails.selectSegment);   
            for (var i = 0; i < selectedSegments.length; i++) {
                if (activeSegDetails.selectSegment[selectedSegments[i]] && activeSegDetails.activeSegments[selectedSegments[i]]) {
                    selectedSegmnetsReq.push({
                        segment: selectedSegments[i]
                    })
                }
            }
            let reqObj = {
                accType: LoginService.getAccData("accTyp"),
                dpID: "none",//non mandatory so sending blank
                demat_holding: "none",//non mandatory so sending blank
                client_type: "PWA",
                segmentdeactivationdetails: selectedSegmnetsReq
            };       
            let createSRRes = await createSegmentDeactivationSR(reqObj);//{"appID": "663051cfbac7d699a1c59b96048b50e7","config": {"app": 1},"data": {"type": "segmentDeactivationResDao","id": 24111,"message": "We have received your request! Following Segments will be deactivated in 2 working days."},"msgID": "7d125c06-db70-4e10-b3c7-4158e74ec8a4"}
        
            if (createSRRes && createSRRes.hasOwnProperty("data") && createSRRes.data.hasOwnProperty("id")) {
                props.setParLoader(false);
                setLoader(false);
                const value = JSON.parse(createSRRes.data.id);
                if (value) {
                    openSRSuccessPopup();
                } else {
                    props.setParLoader(false);
                    openSRErrorPopup();
                }
            } else if(Object.keys(createSRRes).length > 0 && createSRRes.hasOwnProperty("error") && createSRRes.error.errCd === "SR0005") {
                setLoader(false);
                openExistSrPopup();
            } else {
                if (createSRRes && createSRRes.error) {
                    props.setParLoader(false);
                    setLoader(false);
                    openSRErrorPopup();
                }
            }
            setDisableSubmit(false);
        } catch (error) {
            props.setParLoader(false);
            setLoader(false);
            openSRErrorPopup();
            setDisableSubmit(false);
        }
    }

    return (
        <>
        <div className="segmentDeactivate">
          <div className="container">
            {!loader && (
                <div className="segment-body">
                <h3 className="main-heading">Select Segments to Deactivate</h3>
                <div className="segment-container">
                    { (activeSegDetails.activeSegments["NSEFO"] || activeSegDetails.activeSegments["BSEFO"]) && (
                    <div className="segment-box">
                        <div className="segment-checkbox">
                        <Checkbox
                            onChange={(event) => {
                                // if(activeSegDetails.activeSegments["NSEFO"] && ( activeSegDetails.activeSegments["BSEFO"] === undefined)){
                                //     setActiveSegDetails({
                                //        ...activeSegDetails,
                                //        selectSegment : {...activeSegDetails.selectSegment, NSEFO: event.target.checked}
                                //     });
                                //    } else 
                                //    if(activeSegDetails.activeSegments["BSEFO"] && ( activeSegDetails.activeSegments["NSEFO"] === undefined)){
                                //        setActiveSegDetails({
                                //            ...activeSegDetails,
                                //            selectSegment : {...activeSegDetails.selectSegment, BSEFO: event.target.checked}
                                //         });
                                //    } 
                                //    else {
                                       setActiveSegDetails({
                                           ...activeSegDetails,
                                           selectSegment : {...activeSegDetails.selectSegment, NSEFO: event.target.checked, BSEFO: event.target.checked}
                                        });
                                  // }
                            }}
                            checked={activeSegDetails.selectSegment["NSEFO"] && activeSegDetails.selectSegment["BSEFO"]}
                            name=""
                            disabled= {false}
                        />
                        </div>
                        <div className="segment-info">
                            <label className="segment-name">Equity Derivatives</label>
                            <label className="segment-exc">{((activeSegDetails.activeSegments["NSEFO"] === undefined) && (activeSegDetails.activeSegments["BSEFO"] === undefined)) ||  (activeSegDetails.activeSegments["NSEFO"] && activeSegDetails.activeSegments["BSEFO"])? "NSE, BSE" : (activeSegDetails.activeSegments["NSEFO"] && ( activeSegDetails.activeSegments["BSEFO"] === undefined)) ? "NSE" : "BSE"}</label>
                        </div>
                    </div>)}
                    { (activeSegDetails.activeSegments["NSECDS"] || activeSegDetails.activeSegments["BSECDS"]) && (
                    <div className="segment-box">
                        <div className="segment-checkbox">
                        <Checkbox
                            onChange={(event) => {
                                    // if(activeSegDetails.activeSegments["NSECDS"] && ( activeSegDetails.activeSegments["BSECDS"] === undefined)){
                                    //  setActiveSegDetails({
                                    //     ...activeSegDetails,
                                    //     selectSegment : {...activeSegDetails.selectSegment, NSECDS: event.target.checked}
                                    //  });
                                    // } else if(activeSegDetails.activeSegments["BSECDS"] && ( activeSegDetails.activeSegments["NSECDS"] === undefined) && activeSegDetails.selectSegment["BSECDS"] === false){
                                    //     setActiveSegDetails({
                                    //         ...activeSegDetails,
                                    //         selectSegment : {...activeSegDetails.selectSegment, BSECDS: event.target.checked}
                                    //      });
                                    //  } 
                                    // else {
                                        setActiveSegDetails({
                                            ...activeSegDetails,
                                            selectSegment : {...activeSegDetails.selectSegment, NSECDS: event.target.checked, BSECDS: event.target.checked}
                                         });
                                   // }
                            }}
                            checked={activeSegDetails.selectSegment.NSECDS && activeSegDetails.selectSegment.BSECDS}
                            name=""
                            disabled= {false}
                        />
                        </div>
                        <div className="segment-info">
                            <label className="segment-name">Currency Derivatives</label>
                            <label className="segment-exc">{((activeSegDetails.activeSegments["NSECDS"] === undefined) && (activeSegDetails.activeSegments["BSECDS"] === undefined)) ||  (activeSegDetails.activeSegments["NSECDS"] && activeSegDetails.activeSegments["BSECDS"])? "NSE, BSE" : (activeSegDetails.activeSegments["NSECDS"] && ( activeSegDetails.activeSegments["BSECDS"] === undefined)) ? "NSE" : "BSE"}</label>
                        </div>
                    </div>)}
                    { activeSegDetails.activeSegments["BSEMFSS"] && (
                    <div className="segment-box">
                        <div className="segment-checkbox">
                        <Checkbox
                            onChange={(event) => {
                            setActiveSegDetails({
                                    ...activeSegDetails,
                                    selectSegment : {...activeSegDetails.selectSegment ,BSEMFSS  : event.target.checked}
                                });
                            }}
                            checked={activeSegDetails.selectSegment.BSEMFSS}
                            name=""
                            disabled= {false}
                        />
                        </div>
                        <div className="segment-info">
                            <label className="segment-name">Mutual Funds</label>
                            <label className="segment-exc">BSE</label>
                        </div>
                    </div>)}
                    { activeSegDetails.activeSegments["COMMCX"] && activeSegDetails.activeSegments["COMNCDEX"] && (
                    <div className="segment-box">
                        <div className="segment-checkbox">
                        <Checkbox
                            onChange={(event) => {
                                setActiveSegDetails({
                                    ...activeSegDetails,
                                    selectSegment : {...activeSegDetails.selectSegment, COMMCX: event.target.checked, COMNCDEX: event.target.checked}
                            });
                            }}
                            checked={activeSegDetails.selectSegment.COMMCX || activeSegDetails.selectSegment.COMNCDEX}
                            name=""
                            disabled= {false}
                        />
                        </div>
                        <div className="segment-info">
                            <label className="segment-name">Commodity Derivatives</label>
                            <label className="segment-exc">MCX, NCDEX</label>
                        </div>
                    </div>)}
                </div> 
                <div className="segment-error-container">
                    {validationErr.openOrder && (
                        <div className="segment-error-box">
                            <i className="edel-icon-tooltip"></i>
                            <span className="error-msg">
                                {errorMsg["openOrder"].err}{" "}
                                <a className="redirection-link" href={`${errorMsg["openOrder"].link}`}>Click Here </a>
                                {errorMsg["openOrder"].msg}
                            </span>
                        </div>
                    )}
                    {validationErr.openSIP && (
                        <div className="segment-error-box">
                            <i className="edel-icon-tooltip"></i>
                            <span className="error-msg">
                                {errorMsg["openSIP"].err}{" "}
                                <a className="redirection-link" href={`${errorMsg["openSIP"].link}`}>Click Here </a>
                                {errorMsg["openSIP"].msg}
                            </span>
                        </div>
                    )}
                    {validationErr.openPosition && (
                        <div className="segment-error-box">
                            <i className="edel-icon-tooltip"></i>
                            <span className="error-msg">
                                {errorMsg["openPosition"].err}{" "}
                                <a className="redirection-link" href={`${errorMsg["openPosition"].link}`}>Click Here </a>
                                {errorMsg["openPosition"].msg}
                            </span>
                        </div>
                    )}
                </div> 
                {otpSection && (
                    <div className="segment-otpSection">
                        <OtpSection
                            details={{
                                acTyp: LoginService.getAccData("accTyp"),
                                reqTyp: "generate",
                                srType: "Segment Deactivation",
                                srAcType: "none",
                                dpId:"none",
                                type: "mobile_and_email",
                                userType : "RM",
                                mobileNo: mobile,
                                emailId: email,
                                segmentType: getSegNames()
                            }}
                            otpVerified={(token: any) => {
                                setOtpVerified(true);
                            }}
                            setParLoader={(val: boolean) => {
                                props.setParLoader(val);
                            }}
                            showVerify= {!otpVerified}
                            containerClass="segment-otp-box"
                            otpHeader="otp-header"
                            inputClass="text-field"
                        />
                    </div>
                )}
                </div>
            )}    
            {loader && (
                <div
                  style={{
                    textAlign: "center", paddingTop: "37px", paddingLeft: "15px", paddingBottom: "50px",
                  }}
                >
                  <PageLoader size={50}></PageLoader>
                </div>
            )}       
            <div className="segment-footer">
            <button
                type="submit"
                className="btn btn-blue login-btn"
                onClick={(e: any) => {
                    proceedNext();
                    e.preventDefault();
                }}
                disabled = {
                    validationErr.openSIP || validationErr.openPosition || validationErr.openOrder ||
                    checkSegEnabled() || disableSubmit ||
                    (otpSection && !otpVerified)
                }
            >
                Proceed
            </button>
            <button
                type="submit"
                className="btn btn-olink login-btn"
                disabled= {disableSubmit}
            >
                <a className="btn btn-olink login-btn"
                    href={ 
                        window.location.href.includes("ajs") ? config.rootUrl + "clientarea/servicerequest" : config.root + "/clientarea/service-request"
                    }
                >
                    Cancel
                </a>
            </button>
            </div>  
          </div>           
        </div>
        </>
  );
};